import { Routes, Route } from 'react-router-dom';
import { Dashboard } from '../modules/aggregator/pages/Dashboard';
import { Detailsabha } from '../modules/aggregator/pages/Detailsabha';
import { Withoutabha } from '../modules/aggregator/pages/Withoutabha';

const AggregatorRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/details-abha" element={<Detailsabha />} />
      <Route path="/without-abha" element={<Withoutabha />} />
    </Routes>
  );
};

export default AggregatorRoutes;